import { Globe2, Map, MapPin, Building2, Home, Trees, ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useI18n } from "../i18n";
import ListenButton from "./ListenButton";

const PLACES = [
  { icon: Globe2, label: "Countries", color: "#2563EB", id: "worldmap" },
  { icon: Map, label: "States & Provinces", color: "#0D9488", id: "explorer" },
  { icon: MapPin, label: "Counties & Districts", color: "#E0552F", id: "explorer" },
  { icon: Building2, label: "Cities", color: "#1D4ED8", id: "explorer" },
  { icon: Home, label: "Towns", color: "#0D9488", id: "explorer" },
  { icon: Trees, label: "Villages", color: "#16A34A", id: "explorer" },
];

export default function ExploreByPlace() {
  const { tr } = useI18n();
  return (
    <section id="explore" data-testid="explore-by-place-section" className="py-16 lg:py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-4">
            <h2 className="text-2xl md:text-3xl font-extrabold text-[#0F2557] tracking-tight">{tr("Explore by Place")}</h2>
            <ListenButton compact text={`${tr("Explore by Place")}. ${PLACES.map((p) => tr(p.label)).join(", ")}.`} />
          </div>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-8">
          {PLACES.map((p, i) => (
            <Reveal key={p.label} delay={i * 0.06} y={18}>
              <button
                data-testid={`place-card-${p.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => document.getElementById(p.id)?.scrollIntoView({ behavior: "smooth" })}
                className="w-full bg-white border border-[#E5EDF7] rounded-2xl p-6 flex flex-col items-center gap-4 hover:shadow-lg hover:shadow-blue-100 hover:border-[#BFD4F2] hover:-translate-y-1 transition-all duration-300 active:scale-[0.97] group"
              >
                <span className="w-14 h-14 rounded-full flex items-center justify-center" style={{ background: `${p.color}14` }}>
                  <p.icon size={26} style={{ color: p.color }} />
                </span>
                <span className="flex items-center gap-1 font-bold text-sm text-[#0F2557] group-hover:text-[#2563EB] transition-colors text-center leading-tight">
                  {tr(p.label)} <ChevronRight size={14} className="text-[#94A3B8] group-hover:translate-x-0.5 transition-transform" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
